import { Box, Stack } from '@mui/material';
import { Activities } from './Activities';
import { Title } from './Title';
import {
  ActivitiesSearchBar,
  CustomMetaTitle,
  LinkReturnToMain,
} from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

export const ActivitiesLobby = () => {
  return (
    <Stack color={'#081E54'}>
      <CustomMetaTitle
        title={Dictionary[DICTIONARY.ActivitiesLobby].pageTitle}
      />
      <Box mb='32px'>
        <LinkReturnToMain />
      </Box>
      <Title />
      <ActivitiesSearchBar source='activities' />
      <Activities />
    </Stack>
  );
};
